import { Layout, Image } from 'antd';

const { Footer } = Layout;

export const BaseFooter = ({ common, setCommon }) => {
  return (
    <Footer className="footer-container">
      <div className="footer-content">
        <Image
          src="/assets/images/qmir_favicon.ico"
          preview={false}
          className="footer-logo"
        />
        <div className="footer-text">
          서울시 은평구 증산로 337(증산동, 아소비빌딩)(주)아소비교육, 대표자: 박시연
          <br />
          사업자번호: 105-87-49901, 대표번호: 1644-1742, 팩스(fax): 02-335-4310
          <br />
          <br />
          Copyright © ASOBI EDUCATION ALL Rights Reserved.
        </div>
      </div>
    </Footer>
  );
};
